import CardAnalytics from "../CardAnalytics";

export default function OrderCards({
  total,
  pending,
  started,
  completed,
  rejected,
  cancelled,
}) {
  return (
    <div className="row">
      <CardAnalytics
        title="Total"
        description="Total orders received"
        value={total}
        status="text-success"
      />
      <CardAnalytics
        title="Pending"
        description="Orders placed but not started"
        value={pending}
        status="text-warning"
      />
      <CardAnalytics
        title="In Progress"
        description="Orders started in progress"
        value={started}
        status="text-info"
      />
      <CardAnalytics
        title="Completed"
        description="Completed orders"
        value={completed}
        status="text-success"
      />
      <CardAnalytics
        title="Cancelled"
        description="Orders cancelled by User"
        value={cancelled}
        status="text-muted"
      />
      <CardAnalytics
        title="Rejected"
        description="Orders rejected by Chef"
        value={rejected}
        status="text-danger"
      />
    </div>
  );
}
